module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor18-4417aa181ead109f494eacd81df773d0.png";